<template>
  <nav class="navbar navbar-expand-lg p-0">
    <div class="container h-100">
      <a href="https://www.beweegbuddy.be" target="_blank" class="navbar-brand"
         v-hover="onHoverOverLogo">BEWEEGBUDDY</a>
      <button @click="toggleDropdown" class="navbar-toggler" data-toggle="collapse" data-target="#navbarMenu"
              aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation" type="button">
        <span class="navbar-toggler-icon"><MobileCollapseLogo/></span>
      </button>

      <ul class="dropdown-menu" v-if="dropdownOpen">
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/agenda" class="nav-link">
            <span class="nav-logo-wrapper"><CalendarLogo/></span> Agenda
          </router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/activities" class="nav-link">
            <span class="nav-logo-wrapper" v-hover="onHoverOverActivities"><ActivityLogo/></span> Activiteiten
          </router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/news" class="nav-link">
            <span class="nav-logo-wrapper" v-hover="onHoverOverNews"><NewsLogo/></span> Nieuwsberichten
          </router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/profile" class="nav-link">
            <span class="nav-logo-wrapper" v-hover="onHoverOverProfile"><ProfileLogo/></span> Profiel
          </router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown" v-if="isAuthenticated">
          <router-link to="/logout" class="nav-link">
            <span class="nav-logo-wrapper"><LogoutLogo/></span> Afmelden
          </router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown" v-else>
          <router-link to="/login" class="nav-link">
            <span class="nav-logo-wrapper"><LogoutLogo/></span> Aanmelden
          </router-link>
        </li>
      </ul>

      <div id="navbarMenu" class="collapse navbar-collapse h-100">
        <ul class="navbar-nav ml-auto h-100">
          <li class="nav-item">
            <router-link to="/agenda" class="nav-link" v-hover="onHoverOverAgenda">
              <CalendarLogo/>
              Agenda
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/activities" class="nav-link" v-hover="onHoverOverActivities">
              <ActivityLogo/>
              Activiteiten
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/news" class="nav-link" v-hover="onHoverOverNews">
              <NewsLogo/>
              Nieuwsberichten
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/profile" class="nav-link" v-hover="onHoverOverProfile">
              <ProfileLogo/>
              Profiel
            </router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated">
            <router-link to="/logout" class="nav-link">
              <LogoutLogo/>
              Afmelden
            </router-link>
          </li>
          <li class="nav-item" v-else>
            <router-link to="/login" class="nav-link">
              <LogoutLogo/>
              Aanmelden
            </router-link>
          </li>
        </ul>
      </div>

    </div>
    <HoverInfo :show="hoveringOverLogo" :content="'Ga terug naar de website'"></HoverInfo>
    <HoverInfo :show="hoveringOverAgenda" :content="'Plan hier je activiteiten in'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverActivities" :content="'De volledige lijst met activiteiten'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverNews" :content="'Ontdek hier de laatste nieuwtjes over de Beweegbuddy'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverProfile" :content="'Alle info over jou en je verschillende buddy\'s'" :offset-y="12"
               :offset-x="12"></HoverInfo>


  </nav>
</template>

<script>
import NavIcons from "@/mixins/NavIcons";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "MainNav",
  components: {HoverInfo},
  mixins: [ NavIcons ],
  props: {
    isAuthenticated: Boolean
  },
  data()
  {
    return {
      dropdownOpen: false,
      hoveringOverLogo: false,
      hoveringOverAgenda: false,
      hoveringOverActivities: false,
      hoveringOverProfile: false,
      hoveringOverNews: false,
    }
  },
  methods: {
    toggleDropdown()
    {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown()
    {
      this.dropdownOpen = false;
    },
    onHoverOverLogo(state) {
      this.hoveringOverLogo = state;
    },
    onHoverOverAgenda(state) {
      this.hoveringOverAgenda = state;
    },
    onHoverOverActivities(state) {
      this.hoveringOverActivities = state;
    },
    onHoverOverNews(state) {
      this.hoveringOverNews = state;
    },
    onHoverOverProfile(state) {
      this.hoveringOverProfile = state;
    }

  }
}
</script>

<style lang="scss" scoped>
nav
{
  height: 75px;
  background-color: $primary-blue;

  @media (min-width: 992px)
  {
    overflow-x: auto;
  }
}
</style>